import { factory } from '@repo-level/core-front';

export interface LotteryPrize {
  id: number;
  /** the back office name; physical prizes have it, cash and FS may not */
  stuff: string | null;
  awardPlace: number;
  /** null until the draw is over */
  nickname: string | null;
  ticket: string | null;
  wagerMultiplier: number;
  moneyAward: string;
  moneyAwardCents: number;
  freespinsCount: number;
}

export interface LotteryScaleRule {
  /** the deposit from which a ticket costs `priceCents` */
  fromAmountCents: number;
  priceCents: number;
  active: boolean | null;
  currency: string;
}

export interface Lottery {
  id: number;
  title: string;
  /** the currency prize amounts come in */
  currency: string;
  /** shared by all copies of a recurring lottery */
  frontendIdentifier: string;
  inProgress: boolean;
  startAt: string;
  endAt: string;
  /** set once the winners are drawn */
  finishedAt: string | null;
  moneyBudget: string;
  moneyBudgetCents: number;
  groupIds: number[];
  prizes: LotteryPrize[];
  depositScaleRules: Record<string, LotteryScaleRule[]>;
  maxTicketsCountToPlayer: number | null;
  qualificationTickets: number | null;
  lotteryTicketsCount?: number;
  lotteryPlayersCount?: number;
}

export interface LotteryStatus {
  lotteryId: number;
  tickets: string[];
  /** winning ticket -> prize id */
  prizes: Record<string, number>;
}

/** enabled lotteries, available to guests too */
export const lotteries = factory((r) => () => r<Lottery[]>('get', 'lotteries'));

export const lottery = factory(
  (r) => (id: number) => r<Lottery>('get', `lotteries/${id}`)
);

export const lotteryStatuses = factory(
  (r) => () => r<LotteryStatus[]>('get', 'lotteries/statuses')
);

export const lotteryStatus = factory(
  (r) => (id: number) => r<LotteryStatus>('get', `lotteries/${id}/status`)
);

export interface PlayerPrize {
  id: number;
  contestType: 'Lottery' | 'Tournament';
  contestId: number;
}

export const playerPrizes = factory(
  (r) => () => r<PlayerPrize[]>('get', 'prizes')
);

/** the account's next successful deposit brings tickets in it; null opts out */
export const selectLottery = factory(
  (r) => (currency: string, lotteryId: number | null) =>
    r<unknown>('post', `player/accounts/${currency}/select_lottery`, {
      selected_lottery: lotteryId,
    })
);
